import API from 'app/utils/apiClient';

import { toParams } from 'app/utils/url';

const getStoryCheer = (storyId) => API.get(`/stories/${storyId}/cheer/`);

const getStoryCheers = (storyId, page = 1, perPage = 20) => {
  const params = toParams({ page, perPage });
  return API.get(`/stories/${storyId}/cheers/?${params}`);
};

const getStoryCheersRankings = (storyId, page = 1, perPage = 20) => {
  const params = toParams({ page, perPage });
  return API.get(`/stories/${storyId}/cheerer-cumulative-rankings/?${params}`);
};

const donateStory = (
  storyId,
  balloon,
  message,
  episodeId = null,
  voucherId = null
) => {
  if (message) {
    return API.post(`/stories/${storyId}/donation/`, {
      balloon,
      message,
      episodeId,
      ...(voucherId ? { voucherId } : {}),
    });
  }

  return API.post(`/stories/${storyId}/donation/`, { balloon, episodeId });
};

const cheerStory = (storyId, type) =>
  API.post(`/stories/${storyId}/cheer/`, { type });

const getEpisodeDonationRankings = (
  storyId,
  episodeId,
  page = 1,
  perPage = 3
) => {
  const params = toParams({ page, perPage });
  return API.get(
    `/stories/${storyId}/episodes/${episodeId}/donation-cumulative-rankings/?${params}`
  );
};

export default {
  getStoryCheer,
  getStoryCheers,
  getStoryCheersRankings,
  donateStory,
  cheerStory,
  getEpisodeDonationRankings,
};



// WEBPACK FOOTER //
// ./src/app/apis/donation.js